import { Expander, useToggle } from "@evergis/ui";
import React, { FC, useCallback } from "react";
import { useTranslation } from "react-i18next";
import { ExpanderContainer, ExpanderLabel } from "./styled";

export interface ExtendedParametersProps {
  className?: string;
  primary?: boolean;
  initialExpanded?: boolean;
  label?: string;
  onExpand?: (expanded?: boolean) => void;
}

export const ExtendedParameters: FC<ExtendedParametersProps> = ({
  children,
  onExpand,
  className,
  label,
  initialExpanded = false,
  primary = false,
}) => {
  const { t } = useTranslation("dialogs");
  const [expanded, toggleExpanded] = useToggle(initialExpanded);

  const onToggleExpand = useCallback(() => {
    onExpand && onExpand(!expanded);
    toggleExpanded();
  }, [toggleExpanded, expanded, onExpand]);

  return (
    <>
      <ExpanderContainer $primary={primary} className={className}>
        <ExpanderLabel onClick={onToggleExpand}>{label || t("newLayer.extendedParameters")}</ExpanderLabel>
        <Expander primary={primary} onClick={onToggleExpand} isSelected={expanded} />
      </ExpanderContainer>
      {expanded && children}
    </>
  );
};
